// Helpers to build WhatsApp / Instagram links from the admin-configured contact settings.

export function waLink(whatsapp, message) {
  const digits = (whatsapp || "").replace(/[^\d]/g, "");
  if (!digits) return "";
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${digits}${text}`;
}

export function igLink(instagram) {
  const v = (instagram || "").trim();
  if (!v) return "";
  if (/^https?:\/\//i.test(v)) return v;
  return `https://instagram.com/${v.replace(/^@/, "")}`;
}
